'use client'

import { useCallback, useEffect, useState } from 'react'

import { TRoomDetail } from '@/entities/room'
import { mapManager, NaverMap, useMapPin } from '@/shared/lib'

const MAP_ID = 'location-map'

type Props = Pick<TRoomDetail, 'lat' | 'lng'>

export const LocationMap = ({ lat, lng }: Props) => {
  const [scriptLoaded, setScriptLoaded] = useState(false)

  const { createMapPin } = useMapPin()

  const initializeMap = useCallback(() => {
    mapManager.initialize({ center: { lat, lng }, zoom: 15, id: MAP_ID })
  }, [lat, lng])

  const initialize = useCallback(() => {
    if (typeof window === 'undefined') return

    initializeMap()

    createMapPin({ lat, lng })
  }, [lat, lng, initializeMap, createMapPin])

  const handleScriptLoaded = () => {
    setScriptLoaded(true)
  }

  useEffect(() => {
    if (!scriptLoaded) return

    initialize()
  }, [scriptLoaded])

  useEffect(() => {
    return () => {
      mapManager.reset()
    }
  }, [])

  return <NaverMap id={MAP_ID} onReady={handleScriptLoaded} />
}
